var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-home"},[_c('vote-component',{attrs:{"voteKey":_vm.voteKey}})],1),_c('page-footer',{attrs:{"performKey":_vm.voteKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }